/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import { formatDateTime } from 'utilities/formatters';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@blueprintjs/core';

export interface SearchPageListProps {
	title: string;
	data: Array<{ name: string; date: string }>;
}

export function SearchPageList({ title, data }: SearchPageListProps) {
	return (
		<div css={SearchPageListCss}>
			<div className="title">{title}</div>
			<div cy-test={title.toLowerCase().replace(' ', '-') + '-search-list'}>
				{data?.map((d, i) => (
					<Row key={i} d={d} />
				))}
			</div>
		</div>
	);
}

function Row({ d }) {
	const history = useHistory();
	const { url } = useRouteMatch();
	const _onClick = () => {
		const _url = url.slice(-1) === '/' ? url.slice(0, -1) : url;
		history.push(`${_url}/${d.type}/${encodeURIComponent(d.id)}`);
	};
	return (
		<div className="row" onClick={_onClick}>
			<div className="row-name" cy-test={d.type.toLowerCase() + '-row'}>
				<span cy-test={d.type.toLowerCase() + '-row-name'} className="row-name-span" title={d.name}>{d.name}</span>
				<Icon
					icon={
						d.type/*.toLowerCase()*/ === 'Organization'
							? IconNames.SHOP
							: d.type/*.toLowerCase()*/ === 'Vulnerability'
							? IconNames.VIRUS
							: null
					}
				/>
			</div>
			<div className="row-date">{formatDateTime(d.lastOpened)}</div>
		</div>
	);
}

const SearchPageListCss = css`
	overflow: hidden;
	margin-right: 20px;
	min-width: 320px; 

	& .title {
		margin-top: 20px;
		color: #68abda;
		font-weight: bold;
		font-size: 1.1rem;
		text-transform: uppercase;
	}

	& .row {
		margin: 20px 0;
		white-space: nowrap;
		cursor: pointer;

		&:first-of-type(*) {
			margin-top: 10px;
		}

		& .row-name {
			align-items: center;
			font-size: 1rem;
			display: flex;
			
			& .row-name-span {
				text-overflow: ellipsis;
				overflow: hidden;
			}
			
			& .bp3-icon {
				padding-left: 6px;
			}
		}

		& .row-date {
			color: #999999;
			font-size: 0.8rem;
		}
	}
`;
